import { apiClient } from './apiClient';

class PartnerTeamsService {
  // Erstellt ein neues Partner-Team
  async createPartnerTeam(groupId, participant1Id, participant2Id) {
    try {
      const response = await apiClient.post('/partner-teams', {
        groupId,
        participant1Id,
        participant2Id
      });
      
      return {
        success: true,
        data: response,
        message: 'Partner-Team erfolgreich erstellt'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Fehler beim Erstellen des Partner-Teams'
      };
    }
  }

  // Holt alle Partner-Teams einer Gruppe
  async getPartnerTeamsByGroup(groupId) {
    try {
      const response = await apiClient.get(`/partner-teams/group/${groupId}`);
      
      return {
        success: true,
        data: response || [],
        message: 'Partner-Teams erfolgreich geladen'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Fehler beim Laden der Partner-Teams',
        data: []
      };
    }
  }

  // Holt ein einzelnes Partner-Team
  async getPartnerTeamById(id) {
    try {
      const response = await apiClient.get(`/partner-teams/${id}`);
      
      return {
        success: true,
        data: response,
        message: 'Partner-Team erfolgreich geladen'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Fehler beim Laden des Partner-Teams'
      };
    }
  }

  // Löscht ein Partner-Team
  async deletePartnerTeam(id) {
    try {
      await apiClient.delete(`/partner-teams/${id}`);
      
      return {
        success: true,
        message: 'Partner-Team erfolgreich gelöscht'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Fehler beim Löschen des Partner-Teams'
      };
    }
  }

  // Holt verfügbare Teilnehmer für ein Partner-Team
  async getAvailableParticipants(groupId, nationId) {
    try {
      const response = await apiClient.get(`/partner-teams/available-participants/${groupId}/${nationId}`);
      
      return {
        success: true,
        data: response || [],
        message: 'Verfügbare Teilnehmer erfolgreich geladen'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Fehler beim Laden der verfügbaren Teilnehmer',
        data: []
      };
    }
  }
}

export default new PartnerTeamsService();

